import { useTranslation } from "react-i18next";
import {
  ChatTeardropText,
  Palette,
  WhatsappLogo,
  RedditLogo,
  ShoppingBag,
} from "@phosphor-icons/react";

const ICONS = {
  m1: ChatTeardropText,
  m2: Palette,
  m3: WhatsappLogo,
  m4: RedditLogo,
  m5: ShoppingBag,
};

export const AddOns = () => {
  const { t } = useTranslation();
  const items = ["m1", "m2", "m3", "m4", "m5"];

  return (
    <section
      data-testid="programme-addons"
      className="py-24 md:py-32 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            {t("programme.addons.kicker")}
          </p>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
            {t("programme.addons.title")}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            {t("programme.addons.subtitle")}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {items.map((key, i) => {
            const Icon = ICONS[key];
            return (
              <article
                key={key}
                data-testid={`addon-card-${i}`}
                className="group relative rounded-2xl border-2 border-slate-200 bg-white p-8 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1 hover:border-transparent hover:shadow-[0_20px_50px_-20px_rgba(123,97,255,0.3)] hover:adonis-gradient-card overflow-hidden"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-slate-100 transition-all duration-300 group-hover:adonis-gradient group-hover:shadow-lg group-hover:shadow-[#7B61FF]/30">
                  <Icon
                    size={24}
                    weight="light"
                    className="text-slate-900 transition-colors duration-300 group-hover:text-white"
                  />
                </div>

                <h3 className="mt-6 font-heading text-base md:text-lg font-bold tracking-tight text-slate-900">
                  {t(`programme.addons.${key}`)}
                </h3>

                <div className="mt-4 h-px w-8 bg-slate-200 transition-all duration-500 group-hover:w-16 group-hover:adonis-gradient" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AddOns;
